import React from 'react';
import { ToggleRequirementItem } from './ToggleRequirementItem.tsx';
import {
	ENTITY_TABS,
	KycSettingsType,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/types.ts';
import {
	KycSection,
	SectionDivider,
	SectionTitle,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/KycSettings/styles.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { CertificationRequirementToggle } from './CertificationRequirementToggle.tsx';

interface Props {
	type: ENTITY_TABS;
	kycSettings: KycSettingsType;
	/** DC-825: false hides every "require a certified copy" toggle. */
	certificationEnabled: boolean;
}

export const KycRequirementsList: React.FC<Props> = ({
	type,
	kycSettings,
	certificationEnabled,
}) => {
	const tMipManage = useTranslationMipManage();

	return (
		<KycSection $noMaxWidth>
			{type === ENTITY_TABS.INDIVIDUAL ? (
				<>
					<SectionTitle>PROOFS</SectionTitle>
					<ToggleRequirementItem
						title={tMipManage('kyc_settings.proofs.identity.label')}
						description={tMipManage('kyc_settings.proofs.identity.description')}
						checked={kycSettings.settings.proofOfIdentityRequired.checked}
						disabled={
							kycSettings.settings.proofOfIdentityRequired.disabled ||
							!kycSettings.hasPermission
						}
						onToggle={() => kycSettings.toggleSetting('proofOfIdentityRequired')}
						showBorder={false}
					/>
					{certificationEnabled &&
						kycSettings.settings.proofOfIdentityRequired.checked && (
							<CertificationRequirementToggle
								checked={
									kycSettings.settings.proofOfIdentityCertificationRequired
										.checked
								}
								disabled={
									kycSettings.settings.proofOfIdentityCertificationRequired
										.disabled || !kycSettings.hasPermission
								}
								onToggle={() =>
									kycSettings.toggleSetting(
										'proofOfIdentityCertificationRequired'
									)
								}
							/>
						)}
					<ToggleRequirementItem
						title={tMipManage('kyc_settings.proofs.address.label')}
						description={tMipManage('kyc_settings.proofs.address.description')}
						checked={kycSettings.settings.proofOfAddressRequired.checked}
						disabled={
							kycSettings.settings.proofOfAddressRequired.disabled ||
							!kycSettings.hasPermission
						}
						onToggle={() => kycSettings.toggleSetting('proofOfAddressRequired')}
						showBorder={false}
					/>
					{certificationEnabled &&
						kycSettings.settings.proofOfAddressRequired.checked && (
							<CertificationRequirementToggle
								checked={
									kycSettings.settings.proofOfAddressCertificationRequired.checked
								}
								disabled={
									kycSettings.settings.proofOfAddressCertificationRequired
										.disabled || !kycSettings.hasPermission
								}
								onToggle={() =>
									kycSettings.toggleSetting('proofOfAddressCertificationRequired')
								}
							/>
						)}
					<SectionDivider />
					<SectionTitle>DECLARATIONS</SectionTitle>
					<ToggleRequirementItem
						title={tMipManage('kyc_settings.declarations.label')}
						description={tMipManage('kyc_settings.declarations.description')}
						checked={kycSettings.settings.beneficialOwnershipRequired.checked}
						disabled={
							kycSettings.settings.beneficialOwnershipRequired.disabled ||
							!kycSettings.hasPermission
						}
						onToggle={() => kycSettings.toggleSetting('beneficialOwnershipRequired')}
						showBorder={false}
					/>
					<ToggleRequirementItem
						title={tMipManage('kyc_settings.source.label')}
						description={tMipManage('kyc_settings.source.description')}
						checked={kycSettings.settings.sourceOfFundsRequired.checked}
						disabled={
							kycSettings.settings.sourceOfFundsRequired.disabled ||
							!kycSettings.hasPermission
						}
						onToggle={() => kycSettings.toggleSetting('sourceOfFundsRequired')}
						showBorder={false}
					/>
					<ToggleRequirementItem
						title={tMipManage('kyc_settings.political.label')}
						description={tMipManage('kyc_settings.political.description')}
						checked={kycSettings.settings.pepRequired.checked}
						disabled={
							kycSettings.settings.pepRequired.disabled || !kycSettings.hasPermission
						}
						onToggle={() => kycSettings.toggleSetting('pepRequired')}
						showBorder={false}
					/>
				</>
			) : (
				<>
					<SectionTitle>PROOFS</SectionTitle>
					<ToggleRequirementItem
						title={tMipManage('kyc_settings.proofs.vehicle.label')}
						description={tMipManage('kyc_settings.proofs.vehicle.description')}
						checked={kycSettings.settings.proofOfInvestmentVehicleRequired.checked}
						disabled={
							kycSettings.settings.proofOfInvestmentVehicleRequired.disabled ||
							!kycSettings.hasPermission
						}
						onToggle={() =>
							kycSettings.toggleSetting('proofOfInvestmentVehicleRequired')
						}
						showBorder={false}
					/>
					{certificationEnabled &&
						kycSettings.settings.proofOfInvestmentVehicleRequired.checked && (
							<CertificationRequirementToggle
								checked={
									kycSettings.settings
										.proofOfInvestmentVehicleCertificationRequired.checked
								}
								disabled={
									kycSettings.settings
										.proofOfInvestmentVehicleCertificationRequired.disabled ||
									!kycSettings.hasPermission
								}
								onToggle={() =>
									kycSettings.toggleSetting(
										'proofOfInvestmentVehicleCertificationRequired'
									)
								}
							/>
						)}
					<SectionDivider />
					<SectionTitle>DECLARATIONS</SectionTitle>
					<ToggleRequirementItem
						title={tMipManage('kyc_settings.benefical.label')}
						description={tMipManage('kyc_settings.benefical.description')}
						checked={kycSettings.settings.beneficialOwnershipRequired.checked}
						disabled={
							kycSettings.settings.beneficialOwnershipRequired.disabled ||
							!kycSettings.hasPermission
						}
						onToggle={() => kycSettings.toggleSetting('beneficialOwnershipRequired')}
						showBorder={false}
					/>
				</>
			)}
		</KycSection>
	);
};
